import { MessageCircle, CheckCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";

export const FinalCTASection = () => {
  const benefits = [
    "Analizamos tu situación actual y detectamos oportunidades",
    "Te mostramos cómo podemos ayudarte a vender más",
    "Te explicamos cómo sería trabajar juntos paso a paso",
  ];

  return (
    <section id="contact" className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 bg-muted/30">
      <div className="max-w-3xl mx-auto text-center">
        <Reveal>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4 sm:mb-6">
            ¿Listo para dejar de improvisar?
          </h2>
          <p className="text-base sm:text-lg text-primary mb-8 sm:mb-10 max-w-xl mx-auto">
            Agendá una llamada y descubrí cómo conectar todo tu marketing en un solo ecosistema.
          </p>
        </Reveal>

        <Reveal delay={1}>
          <div className="bg-card rounded-2xl border border-border p-6 sm:p-8 mb-8 hover:border-accent transition-colors">
            <h3 className="text-lg sm:text-xl font-bold text-primary mb-5">
              En tu llamada:
            </h3>
            <ul className="space-y-3 text-left max-w-md mx-auto mb-6">
              {benefits.map((b, i) => (
                <li key={i} className="flex items-start gap-2.5">
                  <CheckCircle className="h-4 w-4 text-primary flex-shrink-0 mt-0.5" />
                  <span className="text-sm sm:text-base text-foreground/85">{b}</span>
                </li>
              ))}
            </ul>
            <p className="text-xs sm:text-sm text-foreground/75">
              Sin compromiso · 100% gratis
            </p>
          </div>
        </Reveal>

        <Reveal delay={2}>
          <Button
            size="lg"
            className="group bg-primary hover:bg-primary-hover text-primary-foreground px-8 sm:px-10 py-6 text-base sm:text-lg font-bold rounded-full shadow-lg shadow-primary/15 hover:shadow-primary/25 transition-all duration-300 hover-lift"
            onClick={() => {
              window.open(
                `https://wa.me/50670473873?text=${encodeURIComponent("Hola! Quiero agendar una llamada.")}`,
                "_blank"
              );
            }}
          >
            <MessageCircle className="mr-2 h-5 w-5" />
            Agendar llamada
            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </Button>
        </Reveal>
      </div>
    </section>
  );
};
